<template>
    <div>
        <div>
            <SignInPC v-if="isPC" />
            <SignInH5 v-else />
        </div>
    </div>
</template>
<script>
    import { enableAppShare } from '../../../common/js/APP/share';
    import SignInH5 from '../components/SignInH5';
    import SignInPC from '../components/SignInPC';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC,
        },
        data() {
            return {
                isBView:'',//A版 false     B版 true
            };
        },
        created () {
            enableAppShare({
                title: '成为HR抢着挖的人是一种什么体验？',
                desc: '构建数据分析能力，成为企业抢手的高薪人才',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210301/1614584493081.png'
            });
        },
        methods: {

        },
    };
</script>